import { render, staticRenderFns } from "./InspectionTasks.vue?vue&type=template&id=39cca6b8&scoped=true&"
import script from "./InspectionTasks.vue?vue&type=script&lang=js&"
export * from "./InspectionTasks.vue?vue&type=script&lang=js&"
import style0 from "./InspectionTasks.vue?vue&type=style&index=0&id=39cca6b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cca6b8",
  null
  
)

export default component.exports